import { isPrintableUnicodeCharacterKeyPress } from '@baserow/modules/core/utils/events'
import { consumeAutoEdit } from '@baserow/modules/database/utils/autoEditCell'

export default {
  data() {
    return {
      // Event handler reference for cleanup
      keydownEvent: null,
    }
  },
  /**
   * Origem Flow: célula selecionada via fluxo de criação por teclado (Tab a
   * partir do título ou de outro editor) já abre a lista de opções — as
   * setas e o Enter funcionam de primeira.
   */
  mounted() {
    if (this.selected && !this.readOnly && consumeAutoEdit()) {
      this.$nextTick(() => {
        if (!this.editing) {
          this.toggleDropdown()
        }
      })
    }
  },
  methods: {
    toggleDropdown(value, query) {
      if (this.readOnly) {
        return
      }

      this.$refs.dropdown.toggle(this.$refs.dropdownLink, value, query)
    },
    hideDropdown() {
      this.$refs.dropdown.hide()
    },
    select() {
      this.keydownEvent = (event) => {
        // Origem Flow: Tab com a lista aberta fecha o dropdown e avança para
        // a próxima célula (Shift+Tab volta) — antes o Tab morria aqui e a
        // criação por teclado travava no primeiro seletor.
        if (event.key === 'Tab') {
          if (this.editing) {
            event.preventDefault()
            this.hideDropdown()
            this.$emit(event.shiftKey ? 'selectPrevious' : 'selectNext')
          }
          return
        }

        // If the arrow keys are pressed we don't want to do anything because
        // the GridViewField component will select the next field.
        const ignoredKeys = ['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown']
        if (ignoredKeys.includes(event.key)) {
          return
        }

        // If the space bar key is pressed, we don't want to do anything because it
        // should open the row edit modal.
        if (event.key === ' ') {
          return
        }

        // When the escape key is pressed while editing the value we can hide the
        // dropdown.
        if (event.key === 'Escape' && this.editing) {
          this.hideDropdown()
          return
        }

        // When the enter key, any printable character or F2 is pressed when not editing
        // the value we want to show the dropdown.
        if (
          !this.editing &&
          (event.key === 'Enter' ||
            isPrintableUnicodeCharacterKeyPress(event) ||
            event.key === 'F2')
        ) {
          this.toggleDropdown()
        }
      }
      document.body.addEventListener('keydown', this.keydownEvent)
    },
    beforeUnSelect() {
      document.body.removeEventListener('keydown', this.keydownEvent)
    },
    canSelectNext() {
      return !this.editing
    },
    canKeyboardShortcut() {
      return !this.editing
    },
  },
}
